<!-- 扫码领积分 -->
<template>
    <div class="container">
        <div class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goDrawer"
                    >新增可领取积分商品</Button
                >
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ row }" slot="product">
                        <div class="flex-c">
                            {{ row.product ? row.product.product_name : "" }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="user_packet_sum_money">
                        <div class="flex-c">
                            {{
                                row.user_packet_sum_money
                                    ? row.user_packet_sum_money
                                    : 0
                            }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="user_packet_count">
                        <Button @click="goCount(row)">{{
                            row.user_packet_count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div class="flex-c">
                            <i-switch
                                v-model="row.status"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeStatus(row, $event)"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost @click="goDrawer(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page-container">
                <div>
                    <Checkbox
                        class="mr24 ml24"
                        v-model="del_value"
                        @on-change="handleSelectAll"
                        >全选</Checkbox
                    >
                    <Button type="error" ghost @click="goDel(0)"
                        >删除</Button
                    >
                </div>
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="80">
            <Form :model="formData" label-position="right" :label-width="150">
                <div class="form-title">金额设置</div>
                <FormItem label="积分模式：">
                    <Select
                        class="w300"
                        v-model="formData.mode"
                        clearable
                        filterable
                        placeholder="请选择积分模式"
                    >
                        <Option
                            v-for="item in modeList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="积分数量：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.num"
                        placeholder="请输入积分数量"
                    ></Input>
                </FormItem>
                <FormItem v-if="formData.mode == 1" label="每份积分金额：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.money"
                        placeholder="请输入每份积分金额"
                    ></Input>
                </FormItem>
                <FormItem v-if="formData.mode == 2" label="积分总金额：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.money_sum"
                        placeholder="请输入积分总金额"
                    ></Input>
                </FormItem>
                <div class="form-title">产品设置</div>
                <FormItem label="产品批次：">
                    <Select
                        class="w300"
                        v-model="formData.batch_id"
                        clearable
                        filterable
                        placeholder="请选择产品批次"
                    >
                        <Option
                            v-for="item in batchList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.batch_name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="产品名称：">
                    <Select
                        class="w300"
                        v-model="formData.product_id"
                        clearable
                        filterable
                        placeholder="请选择产品名称"
                    >
                        <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.product_name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="产品经销商：">
                    <Select
                        class="w300"
                        v-model="formData.agent_id"
                        clearable
                        filterable
                        placeholder="请选择产品经销商"
                    >
                        <Option
                            v-for="item in agentList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.agent_name }}</Option
                        >
                    </Select>
                </FormItem>
                <div class="form-title">样式设置</div>
                <div class="dis-flex">
                    <FormItem label="活动页面样式: ">
                        <div class="dis-flex">
                            <div class="form-upload mr12" @click="openModal(1)">
                                <Icon
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                                <div>尺寸200px 270px</div>
                            </div>
                            <div v-if="formData.show_logo" class="form-img">
                                <img class="wh100" :src="formData.show_logo" />
                            </div>
                        </div>
                    </FormItem>
                    <FormItem label="积分领取样式：">
                        <div class="dis-flex">
                            <div class="form-upload mr12" @click="openModal(2)">
                                <Icon
                                    type="ios-add"
                                    size="44"
                                    color="#AEAEB3"
                                />
                                <div>尺寸380px 670px</div>
                            </div>
                            <div v-if="formData.show_style" class="form-img">
                                <img class="wh100" :src="formData.show_style" />
                            </div>
                        </div>
                    </FormItem>
                </div>
                <FormItem label="积分文字1设置: ">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.word1"
                        placeholder="请输入积分文字"
                    ></Input>
                </FormItem>
                <FormItem label="积分文字2设置: ">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formData.word2"
                        placeholder="请输入积分文字"
                    ></Input>
                </FormItem>
                <div class="footer">
                    <Button @click="cancelForm">取消</Button>
                    <Button
                        class="theme-bc ml24 theme-default-color"
                        @click="submitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </Drawer>
        <!-- 参与人数 -->
        <Drawer v-model="countDrawer" title="参与人数" width="80">
            <div>
                <div class="flex-sb mb24">
                    <div>
                        <Select
                            class="w200 mr24"
                            v-model="pageCount.pay_status"
                            clearable
                            filterable
                            placeholder="请选择状态"
                        >
                            <Option
                                v-for="item in payStatusList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </div>
                    <Button
                        class="theme-bc theme-default-color"
                        icon="ios-search"
                        @click="goSearch"
                        >确认搜索</Button
                    >
                </div>
                <Table :columns="columnCount" :data="dataCount" border>
                    <template slot-scope="{ row }" slot="pay_status">
                        <div v-if="row.pay_status == 0">付款中</div>
                        <div v-if="row.pay_status == 1">发放成功</div>
                        <div v-if="row.pay_status == 2">发放失败</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                v-if="row.pay_status == 2"
                                type="primary"
                                ghost
                                @click="goRefresh(row)"
                                >重新发放</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageCount.page"
                        :page-size="pageCount.limit"
                        :total="totalCount"
                        show-elevator
                        show-total
                        @on-change="pageChangeCount"
                    />
                </div>
            </div>
        </Drawer>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    assembly_wxpacket_list,
    assembly_wxpacket_status,
    assembly_wxpacket_delete,
    assembly_wxpacket_info,
    assembly_wxpacket_save,
    assembly_wxpacket_prize,
    assembly_wxpacket_refresh,
    get_options,
} from "@/api/index";
import VueQr from "vue-qr";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { VueQr, pictureLibrary },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { type: "index", width: 60, align: "center" },
                { title: "活动产品", slot: "product", align: "center" },
                { title: "活动总积分", key: "money_sum", align: "center" },
                {
                    title: "已瓜分积分",
                    slot: "user_packet_sum_money",
                    align: "center",
                },
                {
                    title: "参与人数",
                    slot: "user_packet_count",
                    align: "center",
                },
                { title: "状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            drawers: false,
            drawerTitle: "",
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                mode: "",
                num: "",
                money: "",
                money_sum: "",
                logo: "",
                enter_url: "",
                background_url: "",
                style_url: "",
                word1: "",
                word2: "",
                id: "",
                show_logo: "",
                show_enter: "",
                show_background: "",
                show_style: "",
            },
            modeList: [
                { id: 1, name: "固定积分" },
                { id: 2, name: "随机积分" },
            ],
            batchList: [],
            productList: [],
            agentList: [],
            countDrawer: false,
            pageCount: {
                page: 1,
                limit: 10,
                packet_id: "",
                pay_status: -1,
            },
            totalCount: 0,
            columnCount: [
                { type: "index", width: 60, align: "center" },
                { title: "金额（元）", key: "money", align: "center" },
                { title: "兑换码", key: "qrcode_id", align: "center" },
                { title: "领取时间", key: "created_at", align: "center" },
                { title: "发放状态", slot: "pay_status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataCount: [],
            payStatusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "付款中" },
                { id: 1, name: "成功" },
                { id: 2, name: "失败" },
            ],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
        };
    },
    mounted() {
        this.getList();
        this.getOptions();
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_logo = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.logo = param2[i];
                }
                this.$Message.destroy();
            } else if (this.imgtype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.formData.show_style = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formData.style_url = param2[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            assembly_wxpacket_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        // 下拉
        getOptions() {
            get_options()
                .then((res) => {
                    this.productList = res.data.product;
                    this.batchList = res.data.batch;
                    this.agentList = res.data.agent;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Drawer
        goDrawer(row) {
            if (row.id) {
                this.drawerTitle = "编辑积分活动";
                assembly_wxpacket_info({ id: row.id })
                    .then((res) => {
                        this.formData.batch_id = res.data.batch_id;
                        this.formData.product_id = res.data.product_id;
                        this.formData.agent_id = res.data.agent_id;
                        this.formData.mode = res.data.mode;
                        this.formData.num = res.data.num;
                        this.formData.money = res.data.money;
                        this.formData.money_sum = res.data.money_sum;
                        this.formData.logo = res.data.logo;
                        this.formData.enter_url = res.data.enter_url;
                        this.formData.background_url = res.data.background_url;
                        this.formData.style_url = res.data.style_url;
                        this.formData.word1 = res.data.word1;
                        this.formData.word2 = res.data.word2;
                        this.formData.id = res.data.id;
                        this.formData.show_logo = res.data.show_logo;
                        this.formData.show_background =
                            res.data.show_background;
                        this.formData.show_enter = res.data.show_enter;
                        this.formData.show_style = res.data.show_style;
                    })
                    .catch((err) => {
                        this.$Message.error(err.msg);
                    });
            } else {
                this.drawerTitle = "新增积分活动";
                this.formData.batch_id = "";
                this.formData.product_id = "";
                this.formData.agent_id = "";
                this.formData.mode = "";
                this.formData.num = "";
                this.formData.money = "";
                this.formData.money_sum = "";
                this.formData.logo = "";
                this.formData.enter_url = "";
                this.formData.background_url = "";
                this.formData.style_url = "";
                this.formData.word1 = "";
                this.formData.word2 = "";
                this.formData.id = "";
                this.formData.show_logo = "";
                this.formData.show_background = "";
                this.formData.show_enter = "";
                this.formData.show_style = "";
            }
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        cancelForm() {
            this.drawers = false;
        },
        // 确定(提交表单)
        submitForm() {
            assembly_wxpacket_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.drawers = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        assembly_wxpacket_delete({ id: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.del_value = false;
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 1) {
                        assembly_wxpacket_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        changeStatus(row, e) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    let data = {
                        id: row.id,
                        status: e,
                    };
                    assembly_wxpacket_status(data)
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        // 积分领取记录
        getAssemblyWxpacketPrize() {
            assembly_wxpacket_prize(this.pageCount)
                .then((res) => {
                    this.dataCount = res.data.data;
                    this.totalCount = res.data.total;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        pageChangeCount(index) {
            this.pageCount.page = index;
            this.getAssemblyWxpacketPrize();
        },
        goSearch() {
            this.pageCount.page = 1;
            this.getAssemblyWxpacketPrize();
        },
        goCount(row) {
            this.pageCount.packet_id = row.id;
            this.getAssemblyWxpacketPrize();
            this.countDrawer = true;
        },
        goRefresh(row) {
            assembly_wxpacket_refresh({ id: row.id })
                .then((res) => {
                    this.getAssemblyWxpacketPrize();
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.form-title {
    margin-bottom: 24px;
    color: #484e66;
    font-weight: 600;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page-container {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.footer {
    margin: 24px 0 0 0;
    text-align: right;
}
.form-upload {
    width: 100px;
    height: 100px;
    background-color: #fff;
    border: 1px dashed #9fa5bb;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.form-img {
    width: 100px;
    height: 100px;
    border-radius: 4px;
}
.wh100 {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.dis-flex {
    display: flex;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
</style>